module.exports = __webpack_public_path__ + "static/media/澳柯玛授权资质.9b62c891.jpg";